module.exports = __webpack_public_path__ + "static/media/nima-with-mum.419849b5.png";